import React, { useEffect, useState } from "react";
import axios from "axios";
import port from "../img/portfolio.jpg";
import "../Portfolio/Portfolio.css";
import "./Product.css";
import { motion, useScroll, useTransform } from "framer-motion";

function Product() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/public/products`,
          { withCredentials: true }
        );
        setProducts(response.data);
      } catch (error) {
        console.error("Error fetching product data:", error.message);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="portfolio-section">
      <div className="portfolio-container">
        <img src={port} alt="portfolio background" />
        <div className="portfolio-hero-text">
          "Blending Realities. Building Experiences."
        </div>
      </div>

      <div className="product-page-home-background">
      <div className="sticky-scroll-section-product">
        {products.map((product, index) => (
          <ScrollProduct key={index} product={product} index={index} />
        ))}
      </div>
    </div>
    </div>
  );
}

function ScrollProduct({ product, index }) {
  const { scrollYProgress } = useScroll({
    target: undefined,
    offset: ["start end", "end start"],
  });

  const y = useTransform(scrollYProgress, [0, 1], [0, 0]); 
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);


  return (
    <motion.div
      className="product-page-card"
      style={{
        zIndex: product.length - index, 
      }}
    >
      <div className="product-left-content">
        <div className="product-left-content-header">{product.title}</div>
        <div className="product-left-content-para">{product.description}</div>
      </div>
      <div className="product-right-content">
        <img src={product.image} alt={product.title} />
      </div>
    </motion.div>
  );
}

export default Product;
